export interface CognitoConfig {
  aws_user_pools_id: string;
  aws_user_pools_web_client_id: string;
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: number;
    passwordPolicyCharacters: string[];
  };
}

// `aws-exports.js` is generated by `amplify pull` and is gitignored. It only
// exists on Amplify-managed environments (e.g. dev/uat). For environments that
// run on bare Cognito + S3/CloudFront (preuat, preprod), the user pool details
// are supplied via env vars instead.
const awsExportsModules = import.meta.glob<{default: CognitoConfig}>(
  '../aws-exports.js',
  {eager: true}
);
const awsExportsFromFile = Object.values(awsExportsModules)[0]?.default;

const buildFromEnv = (): CognitoConfig | null => {
  const userPoolId = process.env.VITE_APP_COGNITO_USER_POOL_ID;
  const clientId = process.env.VITE_APP_COGNITO_USER_POOL_CLIENT_ID;
  if (!userPoolId || !clientId) return null;
  return {
    aws_user_pools_id: userPoolId,
    aws_user_pools_web_client_id: clientId,
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [
        'REQUIRES_LOWERCASE',
        'REQUIRES_UPPERCASE',
        'REQUIRES_NUMBERS',
      ],
    },
  };
};

const resolveCognitoConfig = (): CognitoConfig => {
  if (awsExportsFromFile) return awsExportsFromFile;
  const fromEnv = buildFromEnv();
  if (fromEnv) return fromEnv;
  throw new Error(
    'Cognito config missing: expected either reactapp/src/aws-exports.js ' +
      '(Amplify-managed environments) or VITE_APP_COGNITO_USER_POOL_ID and ' +
      'VITE_APP_COGNITO_USER_POOL_CLIENT_ID environment variables.'
  );
};

export const cognitoConfig = resolveCognitoConfig();
